// import {applyMixins} from '../chart_helpers/HelperMixin'
import { mergeConfig } from '../utils/configUtils'
import { formatNumber, getMultiFormat } from '../utils/formatUtils'
import { LOCALE_CONFIGS } from '../utils/localeUtils'

import {
  timeFormat as d3_timeFormat,
  timeFormatDefaultLocale as d3_localeFormat,
} from 'd3-time-format'
export default class BaseChart {
  _data = null
  _ghostData = null
  get data() {
    return this._data
  }
  set data(value) {
    this._data = value
    // Guarro este "_helpersUpdated", pero HAY que updatear la primera vez y no las siguientes... no?
    // pues parece que no, el ParalellCoords neceista update del axis helper por si aparecen "ejes nuevos"!!!!
    // if(!this._helpersUpdated)
    this.updateHelpers()
    this._draw()
  }
  get ghostData() {
    return this._ghostData
  }
  set ghostData(value) {
    this._ghostData = value
    this.updateHelpers()
    this._draw()
  }
  get config() {
    return this._config
  }
  set config(value) {
    this._config = value // extractValues(mergeConfig(this._getConfig(),value))
    this.updateHelpers()
    this._draw()
  }

  set configAndData({ config, data }) {
    this._config = config
    this._data = data
    this.updateHelpers()
    this._draw()
  }

  constructor($root) {
    this.$root = $root
    window.__sdv_counter__ = (window.__sdv_counter__ || 0) + 1
    this._chartId = window.__sdv_counter__
    // this.config = mergeConfigValues(this.constructor.defaultConfig,config)
    this.helperListeners = {}
    this.initHelpers()
  }
  getValueFormat(onAxis) {
    let formatString
    let index
    if (this.config.AxisHelper) {
      if (onAxis && onAxis.indexOf('_') >= 0) index = +onAxis.split('_')[1]
      if (index !== undefined && Array.isArray(this.config.AxisHelper[onAxis[0]].valueFormat))
        formatString =
          this.config.AxisHelper[onAxis[0]].valueFormat[index] ||
          this.config.AxisHelper[onAxis[0]].valueFormat[0]
      else if (onAxis) formatString = this.config.AxisHelper[onAxis[0]].valueFormat
      else
        formatString =
          this.config.valueFormat ||
          this.config.AxisHelper.y.valueFormat ||
          this.config.AxisHelper.x.valueFormat
    }
    if (!formatString) formatString = this.config.valueFormat || ''
    return formatString
  }
  getUnit(onAxis) {
    let unit
    let index
    if (onAxis) {
      if (onAxis.indexOf('_') >= 0) index = onAxis.split('_')[1]
      if (this.config.AxisHelper && this.config.AxisHelper[onAxis[0]].unit) {
        if (index !== undefined && Array.isArray(this.config.AxisHelper[onAxis[0]].unit))
          unit = this.config.AxisHelper[onAxis[0]].unit[index]
        else unit = this.config.AxisHelper[onAxis[0]].unit
      } else unit = this.config.unit
    } else {
      if (this.config.unit) unit = this.config.unit
      else if (this.config.AxisHelper)
        unit =
          (this.config.AxisHelper.y && this.config.AxisHelper.y.unit) ||
          (this.config.AxisHelper.x && this.config.AxisHelper.x.unit)
    }
    return unit
  }
  matchFormatString(formatString) {
    let regex = /(?:\[([DNS])\])?(.+)/
    let match = formatString.match(regex)
    return match
  }
  matchMultiFormat(formatString) {
    let regex = /\[(.*?)\]/
    let match = formatString.match(regex)
    return (match && match[1]?.split(',')) || null
  }
  getValueType(onAxis) {
    let match = this.matchFormatString(this.getValueFormat(onAxis))
    return match && match[1]
  }
  formatTooltipValue(value, onAxis) {
    const tooltipValueFormat = onAxis
      ? this.config.TooltipBehavior?.axis?.[onAxis[0]]?.tooltipValueFormat
      : this.config.TooltipBehavior.tooltipValueFormat
    //Clean 'z' axis, just necessary for bubble tooltips
    const mappedAxis = onAxis !== 'z' ? onAxis : null
    let formattedValue
    if (tooltipValueFormat)
      formattedValue = this.formatValueFixed(value, tooltipValueFormat, mappedAxis)
    else formattedValue = this.formatValue(value, mappedAxis)

    let unit = this.getUnit(mappedAxis)
    let unitsThatGoBefore = ['$', '¤', '£', 'R$']
    if (unitsThatGoBefore.indexOf(unit) >= 0) return unit + formattedValue
    if (unit) return formattedValue + ' ' + unit
    return formattedValue
  }
  formatValue(value, onAxis) {
    let formatString = this.getValueFormat(onAxis)
    return this.formatValueFixed(value, formatString, onAxis)
  }
  formatValueFixed(value, formatString, onAxis) {
    let match = this.matchFormatString(formatString)
    let type = match && match[1]
    let format = match && match[2]
    let thouDel = this.config.thousandsDelimiter
    let decDel = this.config.decimalDelimiter
    let restrictedFormats =
      onAxis &&
      this._parent._parent.constructor.dataFormat?.find(
        f => f.axis === onAxis || f.axis[0] === onAxis[0]
      )?.types

    if (this.config.locale && Object.keys(LOCALE_CONFIGS).includes(this.config.locale)) {
      d3_localeFormat(LOCALE_CONFIGS[this.config.locale])
    }

    if (type === 'D' && (!restrictedFormats || restrictedFormats.includes(Date))) {
      let multi = this.matchMultiFormat(format) //format.split('|')
      if (!multi) return d3_timeFormat(format)(value)
      else return getMultiFormat(multi)(value)
    } else if (
      !isNaN(Number(value)) &&
      String(value).replaceAll(' ', '') === String(value) &&
      (!restrictedFormats || restrictedFormats.includes(Number))
    )
      return formatNumber(value, format, thouDel, decDel).toUpperCase()
    else return value //|| '-'
  }

  valueWithUnit(value, onAxis) {
    let formattedValue = this.formatValue(value, onAxis)
    let unit = this.getUnit(onAxis)
    let unitsThatGoBefore = ['$', '¤', '£', 'R$']
    if (unitsThatGoBefore.indexOf(unit) >= 0) return unit + formattedValue
    else if (unit) return formattedValue + ' ' + unit
    else return formattedValue
    // return unit?formattedValue+' '+unit:formattedValue
  }

  initHelpers() {
    // console.log('init helpers')
    this._beforeDraws = []
    this._afterDraws = []
    this._helperIds = []
    this.__proto__.constructor.helpers.forEach(helperDef => {
      let helperClass
      if (typeof helperDef === 'function') {
        helperClass = helperDef
      } else {
        helperClass = helperDef.class
      }
      const { init, beforeDraw, afterDraw, ...rest } = helperClass
      Object.assign(this.__proto__.constructor.prototype, rest)
      init.call(this)
      this._beforeDraws.push(beforeDraw)
      this._afterDraws.push(afterDraw)
      this._helperIds.push(helperClass.configName)
    })
  }

  updateHelpers() {
    if (!this.data) return
    this._helpersUpdated = true
    // console.log('update helpers')
    this.__proto__.constructor.helpers.forEach(helperDef => {
      let helperClass
      if (typeof helperDef === 'function') {
        helperClass = helperDef
      } else {
        helperClass = helperDef.class
      }
      const { update } = helperClass
      update.call(this)
    })
  }

  _draw() {
    if (!this.data) return
    //console.log('----> drawing chart')
    this.beforeHelpers()
    this._beforeDraws.forEach(bd => {
      bd.call(this)
    })
    this.beforeDraw()

    this.draw()

    this.afterDraw()
    this._afterDraws.forEach(ad => {
      ad.call(this)
    })
    this.afterHelpers()
    this.emit('drawn', { data: this.data, config: this.config })
  }

  beforeHelpers() {}
  beforeDraw() {}
  draw() {
    console.warn(`Viz ${this.constructor.name} must implement draw()`)
  }
  afterDraw() {}
  afterHelpers() {}

  _getConfig() {
    // console.log("this.helpers",this.constructor.helpers)
    let config = mergeConfig(
      this.__proto__.constructor.defaultConfig,
      this.constructor.defaultConfig
    )
    return this.constructor.helpers.reduce((res, helperDef) => {
      // let clasDef = h.class || h
      // return mergeConfig(config,{[clasDef.name]:clasDef.defaultConfig})

      // A VER sI SE PUEDE UNIFICAR "BIEN" Con el otro "mergeConfigValues"
      let helperConfig
      let helperClass
      if (typeof helperDef === 'function') {
        helperConfig = {}
        helperClass = helperDef
      } else {
        helperConfig = helperDef.config
        helperClass = helperDef.class
      }
      const { defaultConfig } = helperClass
      let helperName = helperClass.configName
      return mergeConfig({ [helperName]: mergeConfig(defaultConfig, helperConfig) }, res)
    }, config)
  }

  selectById(id) {
    console.warn('should be overriden by selectableHelper')
  }

  // emit(eventName, data) {
  //   this._parent._parent.emit(eventName, data)
  // }
  on(eventName, callback) {
    this.addEventListener(eventName, callback)
  }
  addEventListener(eventName, callback) {
    this.eventListeners ||= {}
    this.eventListeners[eventName] ||= []
    this.eventListeners[eventName].push(callback)
  }
  emit(eventName, data) {
    //CUIDAO! me lo he cargado porqeu petaba el treemap, pero seguro se puede/debe recuperar!
    // data = data ? JSON.parse(JSON.stringify(data)) : undefined
    if (this.eventListeners) {
      this.eventListeners[eventName]?.forEach(cb => {
        cb(data)
      })
    }
    let onName = `on${eventName.charAt(0).toUpperCase() + eventName.slice(1)}`
    if (this[onName]) this[onName](data)

    this._parent._parent.emit(eventName, data)
  }
}
